module.exports = __webpack_public_path__ + "img/27.4bd49366.png";